import bp from 'shared/constants/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 2em;
  padding: 10px;
  label {
    text-align: left;
    margin-bottom: 0;
  }
`
export const Wrapper = styled.div`
  display: grid;
  padding: 1em;
  max-height: 400px;
  overflow: auto;

  button {
    width: 100%;
    border-radius: 0px;
    justify-content: start;
  }
  @media screen and (max-width: ${bp.medium}) {
    grid-template-columns: 100%;
  }
`

export const DropdownWrapper = styled.div(
  (props: { center?: boolean }) => css`
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 1em;
    align-items: center;

    & > span > button {
      line-height: 1.2;
    }

    @media screen and (max-width: ${bp.medium}) {
      grid-auto-flow: row;
      grid-row-gap: 0.5em;
      grid-row-gap: 0.5em;
      text-align: ${props.center ? 'center' : 'left'};
    }
  `
)
